module.exports = __webpack_public_path__ + "img/reply.dbe95c57.svg";